"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconEdit = void 0;
var React = __importStar(require("react"));
var IconEdit = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { id: "Action/ic_edit", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M19.8512,8.3345 L18.4622,9.7345 L14.2472,5.5195 L15.6462,4.1315 C15.7412,4.0365 15.8672,3.9845 16.0002,3.9845 C16.1342,3.9845 16.2592,4.0365 16.3532,4.1315 L19.8522,7.6255 C20.0482,7.8205 20.0482,8.1385 19.8512,8.3345 L19.8512,8.3345 Z M9.3502,18.9235 C9.2872,18.9855 9.2072,19.0305 9.1202,19.0545 L4.1052,19.8745 L4.9232,14.8715 C4.9442,14.7805 4.9902,14.6965 5.0552,14.6325 L13.5372,6.2235 L17.7582,10.4445 L9.3502,18.9235 Z M20.5592,6.9185 L17.0612,3.4245 C16.4952,2.8585 15.5052,2.8585 14.9412,3.4225 L4.3502,13.9235 C4.1502,14.1225 4.0112,14.3735 3.9422,14.6785 L3.0062,20.3985 C2.9802,20.5585 3.0332,20.7205 3.1462,20.8335 C3.2412,20.9285 3.3692,20.9805 3.5002,20.9805 C3.5272,20.9805 3.5542,20.9785 3.5802,20.9735 L9.3012,20.0375 C9.3132,20.0355 9.3242,20.0335 9.3352,20.0305 C9.6092,19.9665 9.8592,19.8275 10.0582,19.6295 L20.5592,9.0405 C21.1442,8.4555 21.1442,7.5035 20.5592,6.9185 L20.5592,6.9185 Z", id: "ic_edit", fill: "#464650" }),
        React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 })))); };
exports.IconEdit = IconEdit;
exports.IconEdit.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconEdit;
